import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListingsListComponent } from './listings-list/listings-list.component';
import { ListingsCreateComponent } from './listings-create/listings-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: ListingsListComponent,
        data: {
          title: "Listings List",
          breadcrumb: "Listings List"
        }
      },
      {
        path: 'create',
        component: ListingsCreateComponent,
        data: {
          title: "Create Listings",
          breadcrumb: "Create Listings"
        }
      },
      {
        path: 'edit/:id',
        component: ListingsCreateComponent,
        data: {
          title: "Edit Listings",
          breadcrumb: "Edit Listings"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ListingsRoutingModule { }
